<template>
  <div
    :class="{ 'bto-sb-widget ': isUS }"
    class="bto-sb-select-dropdown bto-sb-scrollbar"
    v-if="isOpen">
    <div
      class="bto-sb-select-events-item"
      v-for="tournament in tournaments"
      :key="tournament.tournamentId">
      <div class="bto-sb-dropdown-sport" v-if="tournament.sportId">
        <span class="bto-sb-sports-icon" :class="getSportClass(tournament.sportId)"></span>
        <span>{{ tournament.sportName }}</span>
      </div>
      <div class="bto-sb-dropdown-category-name">
        <span
          class="bto-sb-flag bto-sb-flag-oval"
          :class="(tournament.categoryName || '').toLowerCase()"></span>
        <span>{{ tournament.categoryName }} - {{ tournament.tournamentName }}</span>
      </div>
      <div class="bto-sb-dropdown-group-events">
        <div class="bto-sb-dropdown-group-event">
          <ul>
            <li v-for="event in tournament.events" :key="event.matchId" @click="openEvent(event)">
              <div class="bto-sb-event-name">
                <a href="javascript:void(0);">
                  <div class="bto-sb-event-wrap">
                    <span class="bto-sb-event-team">
                      <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="event.isUS || event.awayAtHome ? event.guestTeamIcon :event.homeTeamIcon" >
                        <span class="bto-sb-event-team-logo" v-if="url" v-show="loaded">
                          <img :src="url" alt="" @error="reset" @load="onLoad" />
                        </span>
                      </logo-component>
                      <span class="bto-sb-event-home">
                        {{ event.isUS || event.awayAtHome ? event.guestTeam : event.homeTeam }}
                      </span>
                    </span>
                    <span class="bto-sb-event-score-vs">
                      {{ event.isUS || event.awayAtHome ? "@" : "vs" }}
                    </span>
                    <span class="bto-sb-event-team">
                      <logo-component v-if="showTeamIcon" v-slot="{ url, reset, onLoad, loaded }" :logo-url="event.isUS || event.awayAtHome ? event.homeTeamIcon :event.guestTeamIcon" >
                        <span class="bto-sb-event-team-logo" v-if="url" v-show="loaded">
                          <img :src="url" alt="" @error="reset" @load="onLoad" />
                        </span>
                      </logo-component>
                      <span class="bto-sb-event-away">
                        {{ event.isUS || event.awayAtHome ? event.homeTeam : event.guestTeam }}
                      </span>
                    </span>
                  </div>
                  <div class="bto-sb-event-time" v-if="event.isLiveMatch">
                    <span class="bto-sb-event-time-live" v-if="event.time">{{ event.time }}</span>
                    <span class="bto-sb-event-time-half-live">{{ event.status }}</span>
                  </div>
                  <div class="bto-sb-event-time" v-else>
                    <span class="bto-sb-event-inntime">{{ event.time }}</span>
                    <span class="bto-sb-event-inndate">{{ event.date }}</span>
                  </div>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <inline-message
      v-if="tournaments.length === 0"
      type="info"
      :message="t('Public.NoEventsAvailable')" />
  </div>
</template>
<script>
  import { getSelectEventsTournamentsMap, getSelectEventLists, getFilteredLiveEvents } from 'bto-models/match/details/event-select';
  import { urlFriendlyParam } from '@bto-services/utils';
  import { EVENT_BUS } from '@bto-services/event-bus';
  import { LiveWorker } from "../../../workers";
  import store from '../../../store';

  export default {
    name: 'EventSelect',
    props: {
      isOpen: {
        type: Boolean,
        required: true,
      },
      match: {
        type: Object,
        required: true,
      },
      preMatchEvents: {
        type: Array,
        default: () => ([]),
      },
    },
    data() {
      return {
        allLiveMatches: [],
        isUS: APP_SETTINGS.settings.layout === 'US',
        showTeamIcon: APP_SETTINGS.matchDetails.showTeamIcon,
      };
    },
    computed: {
      tournaments() {
        const liveEvents = this.allLiveMatches;
        const maxEvents = +APP_SETTINGS.matchDetails.maxEventsInChangeEvent || 10;
        const liveLists = getSelectEventLists(liveEvents, this.match, maxEvents);
        const filteredLiveEvents = getFilteredLiveEvents(liveLists, this.match, maxEvents);

        if (!this.match.isLiveMatch && filteredLiveEvents.length < maxEvents) {
          for (let index = 0; index < this.filteredPrematch.length; index++) {
            const event = this.filteredPrematch[index];
            if (event.matchId !== this.match.matchId) {
              filteredLiveEvents.push(event);
            }
            if (filteredLiveEvents.length > maxEvents) {
              break;
            }
          }
        }
        const { tournamentList } = getSelectEventsTournamentsMap(filteredLiveEvents, this.match);
        return tournamentList;
      },
      filteredPrematch() {
        const maxEvents = +APP_SETTINGS.matchDetails.maxEventsInChangeEvent || 10;
        const preLists = getSelectEventLists(this.preMatchEvents, this.match, maxEvents);
        return getFilteredLiveEvents(preLists, this.match, maxEvents);
      },
    },
    created() {
      LiveWorker.addEventListener('message', this.getLiveMatches);
      LiveWorker.postMessage({ ev: 'allLiveMatches', resp: {} });
    },
    beforeDestroy() {
      LiveWorker.removeEventListener('message', this.getLiveMatches);
    },
    methods: {
      getLiveMatches(msg) {
        if (msg.data.type === 'allLiveMatches') {
          this.allLiveMatches = msg.data.data.lm;
        }
      },
      getSportClass(sportId) {
        return store.getters.getSportIconClass(sportId);
      },
      getSportName(sportId) {
        return store.getters.getSportName(sportId).toLowerCase();
      },
      openEvent(match) {
        this.$emit('openEvents');
        const sportName = urlFriendlyParam(this.getSportName(match.sportId) || '');
        const categoryName = urlFriendlyParam(match.tournamentName);
        const eventName = urlFriendlyParam(`${match.homeTeam} vs ${match.guestTeam}`);
        if (this.$route.name === 'matchDetailsLive') {
          EVENT_BUS.emit('liveFixtureMatchClicked', match);
          return;
        }
        if (match.isLiveMatch) {
          this.$router.push({ name: 'seoGameLive', params: { sportName, categoryName, eventName, matchId: match.betRadarId } });
          return;
        }
        this.$router.push({ name: 'seoGame', params: { sportName, categoryName, eventName, matchId: match.matchId } });
      },
    },
  }
</script>